<template>
  <div>
    <div class="boxShell">
      <i class="iconfont icon-chenggong-icon topicon"></i>
      <p class="tip">提交成功</p>
      <Button
        :text="draw"
        :type="danger"
        class="nextStep"
        :click='goToNextPage'
      ></Button>
      <div class="card-list">
        <p class="tip">您还可以申请以下产品</p>
        <div class="card" v-for="item in cardList" :key="item.productId">
          <div class="top">
            <div class="left">{{ item.productName }}</div>
            <div class="right" @click="jumpUrl(item.url)">立即申请</div>
          </div>
            <div class="btm"><span>最高额度：{{item.maxAmount}}</span><span>年化利率：{{item.rate}}<span class="small-txt">起</span></span></div>
        </div>
      </div>
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import Button from '@/components/Button.vue';
import ServerBank from '@/components/ServerBank.vue';

import { checkStatus } from './mixin';

export default {
  name: 'applicationCompleted',
  data() {
    return {
      danger: 'danger',
      draw: '查看我的融资',
      cardList: [
        {
          productId: '1',
          productName: '度小满-满易贷',
          maxAmount: '20万',
          rate: '7.2%',
          url: "https://xindai.duxiaoman.com/xpage/userguide/operation.html#/?&CH=jmall&fr=1erL7w7O60"
        },
      ],
    };
  },
  mixins: [checkStatus],
  components: {
    Button,
    ServerBank
  },
  methods: {
    jumpUrl(url){
      window.location.href = url;
    },
    goToNextPage() {
      window.location.href = '/backloansuper/loan/supermarket/login2Url/v1.0?k=myLoad';
    },
  },
};
</script>
<style scoped>
.boxShell {
  padding-top: 103px;
}
.topicon {
  margin-top: 103px;
  color: #ff6538;
  font-size: 60px;
}
.tip {
  color: #1c2438;
  font-size: 17px;
  text-align: center;
}
.nextStep {
  margin-top: 50px;
  margin-bottom: 50px;
}
.card-list{
  padding: 0 15px;
}
.card-list>.tip{
  text-align: left; 
  font-size: 14px;
}
.card{
  color: #fff;
  border-radius: 4px;
  background: #ff6538;
  padding: 16px;
}
.top{
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding-bottom: 16px;
  border-bottom: 1px dashed #fff;
}
.left{
  font-weight: bold;
}
.right{
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  background: #fff;
  color: #ff6538;
}
.btm{
  font-size: 12px;
  text-align: left;
  padding-top: 12px;
}
.btm>span{
  padding-right: 12px;
}
.btm .small-txt{
  font-size: 10px;
}
</style>
